import React from "react"
import { StaticQuery, graphql, Link } from "gatsby"
import Image from "gatsby-image"

import ThemeToggle from '../components/themeToggle'

import "../scss/components/nav.scss"

export default ({location, title}) => (
  <StaticQuery
    query={logoQuery}
    render={data => {
      const rootPath = `${__PATH_PREFIX__}/`
      let header

    if (location.pathname === rootPath) {
      header = (
        <h1 className="siteTopTitle">
          <Link to={`/`}>
            <Image
              fixed={data.logo.childImageSharp.fixed}
              alt='logo'
              style={{
                minWidth: 50,
                minHeight: 0,
                marginBottom: `0px`,
              }}
            />
          </Link>
        </h1>
      )
    } else {
      header = (
        <h3 className="sitePageTitle">
          <Link to={`/`}>
            <Image
              fixed={data.logo.childImageSharp.fixed}
              alt='logo'
              style={{
                minWidth: 50,
                minHeight: 0,
                marginBottom: `0px`,
              }}
            />
          </Link>
        </h3>
      )
    }
      return(
        <header className="header">
          <div className="headerWrap">
            {header}
            <ThemeToggle />
          </div>
        </header>
      )
    }}
  />
)

const logoQuery = graphql`
  query LogoQuery {
    logo: file(absolutePath: { regex: "/logo.png/" }) {
      childImageSharp {
        fixed(width: 50, height: 50) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`

